import { useSelector } from "react-redux";
import { useI18nContext } from "@hopper-b2b/i18n";
import { GridV2ExplainerBanner } from "../GridV2ExplainerBanner";
import { AccountSelectors } from "@/modules/account";
import { TenantIconNameEnum } from "@/types/tenantIcons";
import { useIsExchangeFlow } from "@/utilities/flights/useIsExchangeFlow";

/**
 * Grid V2 counterpart of PointsEligibilityBanner: tells a shopper whose
 * balance is under the account's minimum to redeem anything why the results
 * show cash prices only. Open on arrival; collapsing keeps icon and title.
 * V1 keeps its own banner untouched.
 */
export const GridV2MinimumRedemptionBanner = ({
  className,
}: {
  className?: string;
}) => {
  const { t, formatNumber } = useI18nContext();
  const isExchangeFlow = useIsExchangeFlow();

  const hasMinimumRedemptionPoints = useSelector(
    AccountSelectors.getHasMinimumRedemptionPoints
  );
  const minimumRedemptionPoints = useSelector(
    AccountSelectors.getMinimumRedemptionPoints
  );

  if (
    hasMinimumRedemptionPoints ||
    !minimumRedemptionPoints ||
    isExchangeFlow
  ) {
    return null;
  }

  return (
    <GridV2ExplainerBanner
      icon={TenantIconNameEnum.pointsCreditCard}
      title={t("gridV2.minimumRedemptionBanner.title", {
        minimum: formatNumber(minimumRedemptionPoints),
      })}
      className={className}
    >
      {t("gridV2.minimumRedemptionBanner.body")}
    </GridV2ExplainerBanner>
  );
};
